// Global Instructions Rule Applied!

/**
 * Centralized string constants used across the application
 * These constants provide a single source of truth for reusable strings
 */

// ========================
// User Display Fallbacks
// ========================
export const UNKNOWN_CONTACT = 'Unknown Contact'
export const UNKNOWN_USER = 'Unknown User'

// ========================
// Success Messages
// ========================
const MESSAGE_TABLE_REFRESHED = 'Table refreshed successfully'
export const MESSAGE_UPDATE_SUCCESSFUL = 'Update Successful'

// ========================
// Fallback Display Values
// ========================
const NO_COMPANY = 'No Company'
const NO_STAGE = 'No Stage'

// ========================
// Section Titles
// ========================
export const SECTION_COMPANY_OVERVIEW = 'Company Overview'
export const SECTION_CONTACT_OVERVIEW = 'Contact Overview'
export const SECTION_PROSPECT_OVERVIEW = 'Prospect Overview'
export const SECTION_INTERACTION_SUMMARY = 'Interaction Summary'
export const SECTION_COMPANY_TEAM = 'Company Team'
export const SECTION_PROSPECT_TEAM = 'Prospect Team'
export const SECTION_INVESTOR_TEAM = 'Investor Team'
export const SECTION_ROUND_INFORMATION = 'Round Information'

// ========================
// Confirmation Messages
// ========================
export const CONFIRM_DELETE_INTERACTION_TITLE = 'Delete Interaction'
export const CONFIRM_DELETE_INTERACTION_DESCRIPTION =
  'Deleting this Interaction will remove it from all relevant records in the Reservoir Portal (Accounts, Deals, etc.). If you just want to remove it from the current record you can delink it. Are you sure you want to continue?'

export const CONFIRM_DELETE_TASK_TITLE = 'Delete Task'
export const CONFIRM_DELETE_TASK_DESCRIPTION =
  'Deleting this Task will remove it from all relevant records in the Reservoir Portal (Accounts, Deals, etc.). If you just want to remove it from the current record you can delink it. Are you sure you want to continue?'

export const CONFIRM_DELETE_CONTACT_TITLE = 'Are you sure you want to delete this contact?'

export const CONFIRM_DELETE_COMPANY_TITLE = 'Are you sure you want to delete this company?'

export const CONFIRM_DELETE_DEAL_TITLE = 'Are you sure you want to delete this deal?'

export const CONFIRM_DELETE_PROSPECT_TITLE = 'Are you sure you want to delete this prospect?'
const CONFIRM_DELINK_INTERACTION_TITLE = 'Delink Interaction'
const CONFIRM_DELINK_INTERACTION_DESCRIPTION =
  'Are you sure you want to delink this interaction? This will remove the relationship but keep the interaction.'
